'use client';
import styled from 'styled-components';

export const StyledCheckoutContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  max-width: 976px;
  margin: 0 auto;
  padding: ${props => props.theme.spacing(0, 4)};

  @media ${props => props.theme.tabletL} {
    padding-bottom: ${props => props.theme.spacing(24)};
  }
`;
export const StyledCheckoutForm = styled.div`
  flex-grow: 1;
  padding: ${props => props.theme.spacing(0, 0, 20)};
  @media ${props => props.theme.tabletL} {
    flex-basis: 512px;
    flex-grow: 0;
  }
`;

export const ShippingAddressHeader = styled.h2`
  ${props => props.theme.typography.heading3};
  margin-top: ${props => props.theme.spacing(8)};
  margin-bottom: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.tablet} {
    margin-bottom: ${props => props.theme.spacing(8)};
  }
`;

export const AccountInfoHeader = styled.h2`
  ${props => props.theme.typography.heading3};
  margin-top: ${props => props.theme.spacing(10)};
  margin-bottom: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.tablet} {
    margin-bottom: ${props => props.theme.spacing(8)};
    margin-top: ${props => props.theme.spacing(15)};
  }
`;

export const IDMeHeader = styled.h2`
  ${props => props.theme.typography.heading3};
  margin-top: ${props => props.theme.spacing(8)};
  margin-bottom: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.tablet} {
    margin-top: ${props => props.theme.spacing(10)};
    margin-bottom: ${props => props.theme.spacing(8)};
  }
`;

export const BillingInfoHeader = styled.h2`
  ${props => props.theme.typography.heading3};
  margin-top: ${props => props.theme.spacing(8)};
  margin-bottom: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.tablet} {
    margin-top: ${props => props.theme.spacing(10)};
    margin-bottom: ${props => props.theme.spacing(8)};
  }
`;
